var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { selectNurseryRecipes } from "../../selectors/selectNurseryInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { GridContainer } from "../generic/grid-layout/GridContainer";
import { actionRecipeSelectBeforeCultivation } from "./actionNursery";
import { GridItemNurseryRecipe } from "./GridItemNurseryRecipe";
import { NurseryCategory } from "./NurseryCategory";
var MasterViewNurseryDOM = /** @class */ (function (_super) {
    __extends(MasterViewNurseryDOM, _super);
    function MasterViewNurseryDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { selectedItemIndex: 0 };
        _this.onRecipeSelect = function (index) {
            var _a = _this.props, recipes = _a.recipes, selectRecipe = _a.selectRecipe, onSelect = _a.onSelect;
            _this.setState({
                selectedItemIndex: index,
            });
            var recipe = recipes[index];
            if (recipe) {
                selectRecipe(recipe);
                if (onSelect) {
                    onSelect(recipe);
                }
            }
        };
        return _this;
    }
    MasterViewNurseryDOM.prototype.render = function () {
        var recipes = this.props.recipes;
        var data = recipes.map(function (recipe) {
            var locaKey = recipe.isUnlocked
                ? recipe.product[0].locaKey
                : IdLoca.floatingText_requBuildingLevel;
            var replacementText = recipe.requiredNurseryLevel
                ? recipe.requiredNurseryLevel.toString()
                : "";
            var replacements = new Map([[ReplacementLoca.zero_0, replacementText]]);
            if (recipe.isUnlocked) {
                recipe.requiredNurseryLevel = undefined;
            }
            return __assign({}, recipe, { locaKey: locaKey,
                replacements: replacements });
        }, []);
        return (React.createElement("div", { className: "nursery-menu__master-view" },
            React.createElement(GridContainer, { gridItemRenderer: GridItemNurseryRecipe, items: data, onSelect: this.onRecipeSelect, selectedIndex: this.state.selectedItemIndex, key: NurseryCategory.Main })));
    };
    return MasterViewNurseryDOM;
}(React.Component));
var mapState = function (state) { return ({
    recipes: selectNurseryRecipes(state),
}); };
var mapDispatch = function (dispatch) { return ({
    selectRecipe: function (recipe) { return dispatch(actionRecipeSelectBeforeCultivation(recipe)); },
}); };
export var MasterViewNursery = connect(mapState, mapDispatch)(MasterViewNurseryDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/nursery/MasterViewNursery.tsx
// module id = 2729
// module chunks = 3